// Fixed category order used on every publication's detail/admin page.
// Not admin-editable — must stay in sync with domain.ValidCategories on
// the backend (same order).
export const CATEGORY_ORDER = ["پرونده ویژه", "برگردان", "مرور", "انگاره", "گفت و گو", "آزاد"];

// Extra categories only used by issue number 12's special two-tier
// نشریه‌ها browsing UI (see IssueDetailPage.js): "درباره مانیفست" groups
// cards under these instead of the standard CATEGORY_ORDER six, which
// stay reachable there under "مانیفست‌ها". Must stay in sync with
// domain.ManifestCategories on the backend (same order).
export const MANIFEST_CATEGORIES = ["آنچه بود", "آنچه هست"];

// A third, flat category shown alongside the two manifest groups on
// issue number 12's special browsing UI (see IssueDetailPage.js) — it
// has no sub-categories of its own, unlike the two groups above. Must
// stay in sync with domain.AppendixCategory on the backend.
export const APPENDIX_CATEGORY = "پیوست";

// Plain-ASCII slugs for each category, used only in the "?category="
// URL query param (see IssueDetailPage.js/PublicationDetailPage.js) so
// a shared link stays readable instead of turning into percent-encoded
// Persian text that some chat apps mangle. Never shown in the UI itself
// — every display still uses the real Persian category name.
const CATEGORY_SLUGS = {
  "پرونده ویژه": "special-feature",
  "برگردان": "translation",
  "مرور": "review",
  "انگاره": "concept",
  "گفت و گو": "conversation",
  "آزاد": "open",
  "آنچه بود": "what-was",
  "آنچه هست": "what-is",
  "پیوست": "appendix",
};

const SLUG_TO_CATEGORY = Object.fromEntries(
  Object.entries(CATEGORY_SLUGS).map(([category, slug]) => [slug, category])
);

export function categoryToSlug(category) {
  return CATEGORY_SLUGS[category] || category;
}

// Returns null for an absent or unrecognized slug, rather than the raw
// input — callers can then fall back to a default category the same
// way they already do when the query param is missing entirely.
export function slugToCategory(slug) {
  return SLUG_TO_CATEGORY[slug] || null;
}
